import { useEffect, useState } from 'react';

import { MCLASS_ASSET } from 'shared/config/entitelment-constants';
import { Asset, useAssets } from 'shared/api/retail';
import { useAdminPortalEntitlement } from 'shared/api/onboarding';
import {
  ENTRYWAYS_PROGRAM_BK,
  useGetUserProgramsAndAppsMESQuery,
} from 'shared/api/entryways';
import { useIsMClassUserCheck } from 'shared/lib/utils';

export const useUserProgramsData = () => {
  const [programsAssets, setProgramsAssets] = useState<Asset[]>([]);

  const isMClassUser = useIsMClassUserCheck();

  const { isLoading: isEntrywaysQueryLoading, data: entrywaysQueryData = [] } =
    useGetUserProgramsAndAppsMESQuery(undefined, {
      skip: !isMClassUser,
    });

  const { userAssets, isLoading: isAssetsLoading } = useAssets();

  const { isLoading: isUserInfoLoading } = useAdminPortalEntitlement();

  const isLoading =
    isAssetsLoading || isEntrywaysQueryLoading || isUserInfoLoading;

  const collectProgramsAssets = (data: Asset[]) => {
    return data
      .reduce((acc: Asset[], asset: Asset) => {
        if (
          asset.metadata.nav?.display &&
          asset.metadata.nav.section === 'Programs' &&
          !asset.metadata.studentOnly
        ) {
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          if (asset.businessKey === MCLASS_ASSET && entrywaysQueryData) {
            const entrywaysProgram = entrywaysQueryData.find(
              (program) => program.businessKey === ENTRYWAYS_PROGRAM_BK,
            );

            if (entrywaysProgram) {
              return [
                ...acc,
                {
                  ...asset,
                  metadata: {
                    ...asset.metadata,
                    dashboard: {
                      ...asset.metadata.dashboard,
                      appUrl: entrywaysProgram.metadata.dashboard.appUrl,
                    },
                  },
                },
              ];
            }
          }

          return [...acc, asset];
        }

        return acc;
      }, [])
      .sort((a: Asset, b: Asset) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
  };

  useEffect(() => {
    if (isLoading) return;

    const userProgramsAssets = collectProgramsAssets(userAssets);

    setProgramsAssets(userProgramsAssets);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, userAssets, isMClassUser]);

  return {
    isLoading,
    userProgramsData: programsAssets,
  };
};
